import { http } from '@/mall/http/index';
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    userinfo: null,
    mall: {
      domain: '',
      live_id: '',
      live_name: '',
      seller_id: null,
      site: '',
      target: ''
    },
    mallTokenInfo: {
      access_token: '',
      face: '',
      nickname: '',
      refresh_token: '',
      uid: 0,
      username: ''
    },
    mallPageSatck: [], //mall里的页面栈
    addrEditItem: {}, //地址列表页-到 编辑页
    snParam: {}, //订单页面到支付页面的参数
    wxShowTipLayer: false, // 微信内提示浏览器打开
    goodsDetailParams: {},

    // suswindow 组件里是否有按钮显示
    suswindowHasBtn: false
  },

  getters: {
    userinfo: (state) => state.userinfo,
    mall: (state) => state.mall,
    mallToken: (state) => state.mallTokenInfo.access_token,
    mallPageSatck: (state) => state.mallPageSatck
  },

  mutations: {
    userinfo: (state, userinfo) => {
      state.userinfo = userinfo;
    },
    SET_MALL: (state, mall) => {
      state.mall = mall;
    },
    SET_MALL_TOKEN: (state, token) => {
      state.mallTokenInfo = token;
    },
    PUSH_MALL_PAGE: (state, name) => {
      console.log('触发vuex');
      state.mallPageSatck.push(name); //防止疯狂点击-还需要查个重
    },
    POP_MALL_PAGE: (state, name) => {
      console.log(name); //先判断一下最后一个元素是不是传进来的页面
      state.mallPageSatck.pop(); //直接删除的是最后一个元素
    },
    TO_LIST_PAGE: (state) => {
      state.mallPageSatck.pop(); //直接删除的是最后一个元素
      state.mallPageSatck.pop(); //直接删除的是最后一个元素
    },
    ADDR_EDIT_ITEM: (state, item) => {
      state.addrEditItem = item;
    },
    SN_PARAM: (state, obj) => {
      state.snParam = { ...obj };
    },
    WX_SHOW_TIP_LAYER: (state, show) => {
      state.wxShowTipLayer = show;
    },
    SET_GOODS_DETAIL_PARAMS: (state, params) => {
      state.goodsDetailParams = params;
    },

    SET_SUSWINDOW_HAS_BTN: (state, params) => {
      state.suswindowHasBtn = params
    }
  },

  actions: {
    // userinfo
    userinfo({ commit, state }) {
      if (state.userinfo) {
        return;
      }

      $$.module.core.auth.$api.userinfo({
        success: (userinfo) => {
          commit('userinfo', userinfo);
        }
      });
    },
    getMallInfo({ commit }) {
      return new Promise((resolve) => {
        console.log(http);
        return http
          .get('/member-service/passport/media/app/live-shop', {
            token: false,
            params: {
              live_id: $$.module.data.room.roomId
            }
          })
          .then((res) => {
            commit('SET_MALL', res);

            // 临时测试使用
            // commit(
            //   'SET_MALL',
            //   Object.assign(res, {
            //     domain: 'https://testv2-api-mall.easttone.com/'
            //   })
            // );
            resolve();
          })
          .catch((error) => {
            console.log('error...', error);
            resolve();
          });
      });
    },
    getMallToken({ commit, state }) {
      // 融媒体token转换为商城token
      return new Promise((resolve) => {
        function converToken(siteId, token, target = 'media', live_id) {
          if (!token) {
            resolve();
            return;
          }
          return http
            .post(
              '/member-service/passport/media/app/login',
              {
                siteId,
                token,
                target,
                live_id
              },
              {
                token: false,
                params: {
                  siteId,
                  token,
                  target,
                  live_id
                }
              }
            )
            .then((res) => {
              commit('SET_MALL_TOKEN', res);
              resolve(res.access_token);
            })
            .catch(() => resolve());
        }

        Promise.resolve($$.token.get()).then((token) => {
          if (token) {
            converToken(state.mall.site, token, state.mall.target, state.mall.live_id);
          } else {
            resolve();
          }
        });
      });
    },
    // push页面栈
    pushMAllPage(context, name) {
      context.commit('PUSH_MALL_PAGE', name);
    },
    // pop页面栈
    popMAllPage(context, name) {
      context.commit('POP_MALL_PAGE', name);
    },
    // 返回列表也
    toListPage(context) {
      context.commit('TO_LIST_PAGE');
    },
    addrEditItem(context, item) {
      context.commit('ADDR_EDIT_ITEM', item);
    },
    snParam(context, obj) {
      context.commit('SN_PARAM', obj);
    }
  }
});

export default store;
